<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ABONNEMENT_LIST')">
        <slot name="section-abonnement-list">
          <section-abonnement-list ref="ABONNEMENT_LIST"
                                   id="ABONNEMENT_LIST"
                                   :extended="isExtended('ABONNEMENT_LIST')"
                                   :showButton="true"
                                   :autoSave="true"
                                   :readOnly="readOnly"
                                   :moduleId="moduleId"
                                   :searchText="searchText"
                                   :ressourceHeader="ressource"
                                   :fiche="fiche"
                                   :subscription=selectedSubscription
                                   :route="route"
                                   :attribut="attribut"
                                   @extended="setExtended"
                                   @fullscreen="setFullscreen"
                                   @status="updateStatus"
                                   @toggleCardView="toggleCardView"
                                   @updated="subscriptionUpdated"
                                   @selectItem = "selectItem">
          </section-abonnement-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Subscription from '@/extend/classes/Subscription';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionAbonnementList from '@/extend/sections/SectionAbonnementListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionAbonnementList,
    FicheHeader,
  },

  props: {
    subscription: {
      type: Object as PropType<Subscription>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.ABONNEMENT_LIST,
      sections: [
        'ABONNEMENT_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_ABONNEMENT_LIST);
    },

    selectedSubscription (): Subscription {
      return this.subscription
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    subscriptionUpdated (subscription: Subscription) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.subscription || this.subscription.id < 0) && value == 'ABONNEMENT_LIST') {
        this.setExtended(new Extended('ABONNEMENT_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
